import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-dom-object-type',
  templateUrl: './dom-object-type.component.html',
  styleUrls: ['./dom-object-type.component.css']
})
export class DomObjectTypeComponent implements OnInit {
    domObjectTypeKeyno;

    public edit?: Edit;

    public selectListDomObjectTypes: DomObjectTypeItem[] = [];

    public saving = false;

    public domObjectTypeButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fa fa-solid fa-bars', goto: 'domobjecttypes' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.domObjectTypeKeyno = this.stateService.getStateParams()['domobjecttype_keyno'];
    }

    private async loadEdit() {
        if (!!this.domObjectTypeKeyno) {
            this.edit = (await this.datatask.Post(3018, { domobjecttype_keyno: this.domObjectTypeKeyno }))[0];
        }
    }

    private async loadDomObjectTypes(): Promise<void> {
        this.selectListDomObjectTypes = await this.datatask.Post(3020);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3019, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadDomObjectTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    domobjecttype_keyno: number;
    domobjecttype_name: string;
    reg_datetime: string;
    reg_by_portal_user_keyno: string;
    domobjecttypetype_id: string;
    glyphicon: string;
    glyphicon_color: string;
}

interface DomObjectTypeItem {
    domobjecttypetype_id: string;
    domobjecttypetype_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('domObjectType', {
//        templateUrl: 'views/components/views/domObjectType/domObjectType.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'domObjectTypeService', function ($stateParams, stateService, translateService, modalService, domObjectTypeService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let domObjectTypeKeyno = $stateParams.domobjecttype_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                domObjectTypeButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('domobjecttypes') }
//                ],
//                edit: {},
//                selectListDomObjectTypes: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.edit = (await domObjectTypeService.getDomObjectType({ domobjecttype_keyno: domObjectTypeKeyno }))[0];
//            }

//            async function loadDomObjectTypes() {
//                vm.model.selectListDomObjectTypes = await domObjectTypeService.listDomObjectTypes();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                domObjectTypeService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadSetting();
//                loadDomObjectTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
